import { Box, Typography } from '@mui/material';
const NoPermissionsRows = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
      }}
    >
      <Typography variant="h6" color="text.secondary">
        Items are Unavailable.
      </Typography>
      <Typography color="text.secondary">
        Contact your program admin for more details regarding your user
        privileges.
      </Typography>
    </Box>
  );
};

export default NoPermissionsRows;
